import { Injectable } from '@angular/core';
import { cmsApi } from '../constants/constants';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SentemailService {

  constructor(private http: HttpClient) { }

  setEmail(subject, name, Tel, Email, Detail) {
    let _getNewsPeriodUrl = cmsApi + '/sentmail/'
    let _getNewsPeriodBody = {



      subject: subject,
      name: name,
      Tel: Tel,
      Email: Email,
      Detail: Detail




    }
    return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody)
  }




}
